import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Sidebar from '@/components/layout/Sidebar';
import Footer from '@/components/layout/Footer';
import HomePage from '@/pages/HomePage';
import MatchPage from '@/pages/MatchPage';
import HistoryPage from '@/pages/HistoryPage';

/**
 * Componente radice dell'applicazione V‑Spot.
 * Configura il layout globale (Header, Sidebar, Footer) e il routing
 * verso le pagine principali (Home, Match, History).
 */
const App: React.FC = () => {
  return (
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <div style={{ display: 'flex', flex: 1 }}>
          <Sidebar />
          <main style={{ flex: 1, backgroundColor: '#f8fafc', padding: '1.5rem', overflowY: 'auto' }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/match/:videoId" element={<MatchPage />} />
              <Route path="/history" element={<HistoryPage />} />
              {/* Rotta fallback: reindirizza alla home */}
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;